"use client";

import { Github, Facebook, Instagram, Mail } from "lucide-react";
import { useTranslations } from "next-intl";

export function Footer() {
  const tFooter = useTranslations("Footer");
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: tFooter("panel"), href: "https://panel.devdj.pl", external: true },
    {
      label: tFooter("status"),
      href: "https://status.devdj.pl",
      external: true,
    },
    { label: tFooter("docs"), href: "https://docs.devdj.pl", external: true },
    {
      label: tFooter("translations"),
      href: "https://translate.devdj.pl",
      external: true,
    },
    { label: tFooter("privacy"), href: "/privacy-policy", external: false },
  ];

  const socialLinks = [
    {
      href: "https://facebook.com/DevDJpl",
      icon: Facebook,
      label: "Facebook",
    },
    {
      href: "https://instagram.com/DevDJpl",
      icon: Instagram,
      label: "Instagram",
    },
    {
      href: "https://github.com/DevDJpl",
      icon: Github,
      label: "GitHub",
    },
    {
      href: "mailto:contact@devdj.pl",
      icon: Mail,
      label: "Email",
    },
  ];

  return (
    <footer className="border-t border-(--border-subtle) bg-(--bg-primary) py-8 md:py-12">
      <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4">
        {/* Copyright - Left on Desktop, Bottom on Mobile */}
        <div className="text-sm text-(--text-secondary) order-3 md:order-1">
          &copy; {currentYear}{" "}
          <span className="font-bold text-(--text-primary)">DevDJ</span> - All
          Rights Reserved.
        </div>

        {/* Links - Center/Right on Desktop */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 order-2 md:order-2">
          {footerLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="text-sm font-medium text-(--text-secondary) hover:text-(--brand-primary) transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Socials - Right on Desktop, Top on Mobile - Styled EXACTLY like Portfolio Menu */}
        <div className="order-1 md:order-3">
          <div className="inline-flex flex-wrap justify-center gap-3 p-1.5 rounded-full bg-(--bg-card) border border-(--border-subtle) shadow-sm select-none">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target={social.href.startsWith("mailto") ? undefined : "_blank"}
                rel={
                  social.href.startsWith("mailto")
                    ? undefined
                    : "noopener noreferrer"
                }
                className="relative px-1 rounded-full text-sm font-bold tracking-wide transition-all duration-300 cursor-pointer text-(--text-secondary) hover:text-(--text-primary)"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
